import React from 'react';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { Money } from 'modules';

interface InstallmentsPlanTableProps {
  plan: GQL.IInstallmentsPlan;
}

const InstallmentsPlanTable = ({ plan }: InstallmentsPlanTableProps) => {
  return (
    <Table variant="table-hover" className="mb-0">
      <thead>
        <tr>
          <th style={{ width: '40%' }}>Poradie</th>
          <th style={{ width: '33%' }}>Dátum platby</th>
          <th className="text-right">Splátka</th>
        </tr>
      </thead>
      <tbody>
        {plan?.paymentsPlan?.map((payment: any, index: number) => {
          return (
            <tr key={index}>
              <th>{payment.index + 1}. mesiac</th>
              <th>{moment(payment.date).format('D. M. YYYY')}</th>
              <td align="right">
                <Money value={payment.payment || 0} />
              </td>
            </tr>
          );
        })}
      </tbody>
      {plan?.price && (
        <tfoot>
          <tr>
            <td colSpan={5} className="text-right">
              Celkom:{' '}
              <strong>
                <Money value={plan.price} />
              </strong>
            </td>
          </tr>
        </tfoot>
      )}
    </Table>
  );
};

export default InstallmentsPlanTable;
